module.exports = __webpack_public_path__ + "static/media/donation.6282f03f.svg";